/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-script-url */

import React from 'react';
import { Translate } from 'react-redux-i18n';
import { Link } from 'react-router';
import SvgIcon from 'components/common/SvgIcon';
import { isNullOrWhitespace } from 'vdlib';

const NavItem = ({
  active,
  children,
  icon,
  iconClassName,
  onToggle,
  openModal,
  open,
  title,
  url,
}) => {
  const heightRef = React.useRef(0);
  const handleRef = React.useCallback(elem => {
    if (elem) heightRef.current = elem.scrollHeight;
  }, []);

  const openClass = open === true ? 'open' : '';
  const activeClass = active === true ? 'active' : '';
  const hasChildren = !!children;

  const Icon = React.useMemo(
    () =>
      icon ? (
        <SvgIcon name={icon} />
      ) : iconClassName ? (
        <i className={iconClassName} key={'i'} />
      ) : null,
    [icon, iconClassName]
  );

  const linkChildren = React.useMemo(
    () => (
      <React.Fragment>
        {Icon}
        <Translate className="title" value={title} />
        {hasChildren && <span className="arrow" />}
      </React.Fragment>
    ),
    [hasChildren, Icon, title]
  );

  return (
    <li className={`nav-item start ${openClass} ${activeClass}`}>
      {isNullOrWhitespace(url) ? (
        <a
          href="javascript:;"
          className={`nav-link ${hasChildren ? ' nav-toggle' : ''}`}
          onClick={onToggle}
        >
          {linkChildren}
        </a>
      ) : url.indexOf('modal_') > -1 ? (
        <a
          href="javascript:;"
          className={`nav-link ${hasChildren ? ' nav-toggle' : ''}`}
          onClick={() => openModal(url.split('_')[1])}
        >
          {linkChildren}
        </a>
      ) : (
        <Link
          to={url}
          className={`nav-link ${hasChildren ? ' nav-toggle' : ''}`}
        >
          {!Icon && <i className="menu-bullet" />}
          {linkChildren}
        </Link>
      )}
      {hasChildren && (
        <ul
          className="sub-menu"
          ref={handleRef}
          style={{ maxHeight: open ? heightRef.current : '0px' }}
        >
          {children}
        </ul>
      )}
    </li>
  );
};

export default NavItem;
